import type { GetSalesCustomerListQuery, GetSalesProductListQuery, Location } from "@/graphql/codegen/graphql"

export type SalesCustomer = Extract<
  GetSalesCustomerListQuery["location"]["listBillingLocations"],
  { __typename: "BillingLocationListSuccess" }
>["billingLocations"][number]

export type SalesProduct = Extract<
  GetSalesProductListQuery["product"]["list"],
  { __typename: "ProductListSuccess" }
>["products"][number]

export type SalesRequester = SalesCustomer["productManagers"][number]

export interface AddedProduct {
  product: SalesProduct
  requestQuote: boolean
  isExpanded: boolean
}

export enum NewRequestStep {
  Customer = "customer",
  RequesterAndLocations = "requesterAndLocations",
  Product = "product",
}

export interface NewRequestFormValues {
  customer: SalesCustomer
  requesters: SalesRequester[]
  locations: Location[]
  products?: AddedProduct[]
}
